// extracted by mini-css-extract-plugin
module.exports = {"image":"ImageIcon_image__3q6cu","image-squircle":"ImageIcon_image-squircle__2fCmM","image-circle":"ImageIcon_image-circle__2VE0c","fallback":"ImageIcon_fallback__3g04m"};